export default __webpack_public_path__ + "static/media/330_business04-it-mobile.94349c35.png";